import * as z from "zod/v4";

export const SpellCheckImageError = z.object({
  text: z.string(),
  suggestion: z.string().optional(),
});

export type SpellCheckImageError = z.infer<typeof SpellCheckImageError>;
